export default "/kiban/_next/static/images/cnt-7e66cf87af1815222f4ab017293ec9e4.png";